(function () {
  "use strict";
  document.addEventListener("DOMContentLoaded", function () {
    var button = document.getElementById("ac_creation_xport");
    var target = document.getElementById("usr_count");

    if (button && target) {
      button.addEventListener("click", function (e) {
        e.preventDefault();

        target.textContent = "Loading…";

        fetch("/myhoover/new-users-count", {
          method: "GET",
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
          },
        })
          .then(function (resp) {
            if (!resp.ok) {
              throw new Error("Network response was not OK: " + resp.status);
            }
            return resp.json();
          })
          .then(function (data) {
            if (data && data.success) {
              var months = data.months || {};
              var monthKeys = Object.keys(months);

              //-- Group months by year
              var yearBuckets = {};

              monthKeys.forEach(function (key) {
                var parts = key.split("-");
                var year = parts[0];

                if (!yearBuckets[year]) {
                  yearBuckets[year] = [];
                }

                yearBuckets[year].push({
                  key: key,
                  label: months[key].label || key,
                  count: months[key].count || 0,
                });
              });
              // Sort years descending (latest year first)
              var years = Object.keys(yearBuckets).sort(function (a, b) {
                return b.localeCompare(a);
              });

              // Sort months inside each year (Dec → Jan)
              years.forEach(function (year) {
                yearBuckets[year].sort(function (a, b) {
                  return b.key.localeCompare(a.key);
                });
              });

              var html = `
            <h3 style="margin-bottom: 10px;">Accounts Created Per Month</h3>
           
            <p text-align:center;><strong>Total accounts (all shown months):</strong> ${
              data.total || 0
            }</p>
          `;

              years.forEach(function (year) {
                html += `
              <h3 style="text-align: center; margin: 20px 0 8px 0;">
                ${year}
              </h3>

              <table border="1" cellpadding="8" cellspacing="0"
                     style="border-collapse: collapse; width: 100%; margin-bottom: 16px;">
                <thead>
                  <tr>
                    <th style="text-align:left;">Month</th>
                    <th style="text-align:right;">Accounts Created</th>
                  </tr>
                </thead>
                <tbody>
            `;

                yearBuckets[year].forEach(function (m) {
                  html += `
                <tr>
                  <td>${m.label.replace(year, "").trim()}</td>
                  <td style="text-align:right;">${m.count}</td>
                </tr>
              `;
                });

                html += `
                </tbody>
              </table>
            `;
              });

              target.innerHTML = html;
            } else if (data && data.message) {
              target.textContent = "Error: " + data.message;
            } else {
              target.textContent = "Unexpected response";
            }
          })
          .catch(function (err) {
            console.error("Fetch error", err);
            target.textContent = "Request failed: " + err.message;
          });
      });
    }

    // affiliation_xport btn handler -- get affiliation

    var affButton = document.getElementById("affiliation_xport");
    var affTarget = document.getElementById("affiliation_count");

    if (affButton && affTarget) {
      affButton.addEventListener("click", function (e) {
        e.preventDefault();
        affTarget.textContent = "Loading…";

        fetch("/myhoover/monthly-affiliations", {
          method: "GET",
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
          },
        })
          .then(function (resp) {
            if (!resp.ok) {
              throw new Error("Network response was not OK: " + resp.status);
            }
            return resp.json();
          })
          .then(function (data) {
            if (data && data.success) {
              const monthKeys = Object.keys(data.months).sort();

              const firstKey = monthKeys[0];
              const lastKey = monthKeys[monthKeys.length - 1]; 
              
              const firstLabel = data.months[firstKey].label;
              const lastLabel = data.months[lastKey].label;

              let result = {}
              Object.values(data.months).forEach((month)=>{
                Object.entries(month.affiliations).forEach(([affiliation, value])=>{
                  if(!result[affiliation]){
                    result[affiliation] = 0
                  }
                  result[affiliation] += value.count;
                })
              })
              const sortedEntries = Object.fromEntries(Object.entries(result).sort((a,b)=>a[0].localeCompare(b[0])))

              var html = `
                  <h3 style="margin: 20px 0;">Affiliation from <strong>${firstLabel}</strong> to <strong>${lastLabel }</strong></h3>
                
                `;


                      html += `
                    <table border="1" cellpadding="8" cellspacing="0"
                          style="border-collapse: collapse; width: 100%; margin-top: 4px; margin-bottom: 12px;">
                      <thead>
                        <tr>
                          <th style="text-align:left;">Affiliation</th>
                          <th style="text-align:right;">Count</th>
                        </tr>
                      </thead>
                      <tbody>
                  `;

                  Object.entries(sortedEntries).forEach(function ([aff, count]) {
                    html += `
                  <tr>
                    <td>${aff}</td>
                    <td style="text-align:right;">${count}</td>
                  </tr>
                `;
                  });

                  html += `
                  </tbody>
                </table>
              `;

              affTarget.innerHTML = html;
            } else if (data && data.message) {
              affTarget.textContent = "Error: " + data.message;
            } else {
              affTarget.textContent = "Unexpected response";
            }
          })
          .catch(function (err) {
            console.error("Fetch error (monthly-affiliations)", err);
            affTarget.textContent = "Request failed: " + err.message;
          });
      });
    }

    //------ inactive accounts --------

    var inactiveButton = document.getElementById("inactive_ac_xport");
    var inactiveTarget = document.getElementById("inactive_ac_count");

    if (inactiveButton && inactiveTarget) {
      inactiveButton.addEventListener("click", function (e) {
        e.preventDefault();
        inactiveTarget.textContent = "Loading…";

        fetch("/myhoover/inactive-accounts", {
          method: "GET",
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
          },
        })
          .then(function (resp) {
            if (!resp.ok) {
              throw new Error("Network response was not OK: " + resp.status);
            }
            return resp.json();
          })
          .then(function (data) {
            if (data && data.success) {
              var months = data.months || {};
              var monthKeys = Object.keys(months);

              // Group by year like your other view
              var yearBuckets = {};

              monthKeys.forEach(function (key) {
                // key format: YYYY-MM
                var parts = key.split("-");
                var year = parts[0];
                var m = months[key];

                if (!yearBuckets[year]) {
                  yearBuckets[year] = [];
                }

                var total = m.total || 0;
                var inactive = m.inactive || 0;
                var active = total - inactive;
                if (active < 0) {
                  active = 0;
                }

                yearBuckets[year].push({
                  key: key,
                  label: m.label || key,
                  total: total,
                  inactive: inactive,
                  active: active,
                });
              });

              // Sort years descending (latest first)
              var years = Object.keys(yearBuckets).sort(function (a, b) {
                return b.localeCompare(a);
              });

              // Sort months inside each year (Dec → Jan)
              years.forEach(function (year) {
                yearBuckets[year].sort(function (a, b) {
                  return b.key.localeCompare(a.key);
                });
              });

              var html = `
            <h3 style="margin-bottom: 10px;">Inactive vs Active Accounts Per Month</h3>
            
          `;

              years.forEach(function (year) {
                html += `
              <h3 style="text-align: center; margin: 20px 0 8px 0;">
                ${year}
              </h3>

              <table border="1" cellpadding="8" cellspacing="0"
                     style="border-collapse: collapse; width: 100%; margin-bottom: 16px;">
                <thead>
                  <tr>
                    <th style="text-align:left;">Month</th>
                    <th style="text-align:right;">Total Accounts</th>
                    <th style="text-align:right;">Inactive Accounts</th>
                    <th style="text-align:right;">Active Accounts</th>
                  </tr>
                </thead>
                <tbody>
            `;

                yearBuckets[year].forEach(function (m) {
                  // Show just the month name (remove year from label)
                  var monthName = m.label.replace(year, "").trim();

                  html += `
                <tr>
                  <td>${monthName}</td>
                  <td style="text-align:right;">${m.total}</td>
                  <td style="text-align:right;">${m.inactive}</td>
                  <td style="text-align:right;">${m.active}</td>
                </tr>
              `;
                });

                html += `
                </tbody>
              </table>
            `;
              });

              inactiveTarget.innerHTML = html;
            } else if (data && data.message) {
              inactiveTarget.textContent = "Error: " + data.message;
            } else {
              inactiveTarget.textContent = "Unexpected response";
            }
          })
          .catch(function (err) {
            console.error("Fetch error (inactive-accounts)", err);
            inactiveTarget.textContent = "Request failed: " + err.message;
          });
      });
    }

    // ------------------
    // provider count
    // ------------------

    var proC_Btn = document.getElementById("provider_xport");
    var providerCountDiv = document.getElementById("provider_count_wrap");
    console.log("")
    
    if (proC_Btn && providerCountDiv) {
      proC_Btn.addEventListener("click", function (e) {
        e.preventDefault();
        providerCountDiv.textContent = "Loading…";

        fetch("/myhoover/provider-counts", {
          method: "GET",
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
          },
        })
          .then(function (resp) {
            if (!resp.ok) {
              throw new Error("Network response was not OK: " + resp.status);
            }
            return resp.json();
          })
          .then(function (data) {
            if (data && data.success) {

              var months = data.months || {};
              var monthKeys = Object.keys(months);

              // Group by year
              var yearBuckets = {};

              monthKeys.forEach(function (key) {
                // key format: YYYY-MM
                var parts = key.split("-");
                var year = parts[0];
                var m = months[key];

                if (!yearBuckets[year]) {
                  yearBuckets[year] = [];
                }

                var total = m.total || 0;
                var providers = m.providers || {};
                var google = (providers.google && providers.google.count) || 0;
                var email = (providers.email && providers.email.count) || 0;
                var other = (providers.other && providers.other.count) || 0;

                yearBuckets[year].push({
                  key: key,
                  label: m.label || key,
                  total: total,
                  google: google,
                  email: email,
                  other: other,
                });
              });

              // Sort years descending
              var years = Object.keys(yearBuckets).sort(function (a, b) {
                return b.localeCompare(a);
              });

              // Sort months inside each year (Dec → Jan)
              years.forEach(function (year) {
                yearBuckets[year].sort(function (a, b) {
                  return b.key.localeCompare(a.key);
                });
              });

              var html = `
            <h3 style="margin-bottom: 10px;">Accounts by Provider (Google vs Email)</h3>
            <p><strong>Total accounts (all shown months):</strong> ${
              data.total || 0
            }</p>
          `;

              years.forEach(function (year) {
                html += `
              <h3 style="text-align: center; margin: 20px 0 8px 0;">
                ${year}
              </h3>

              <table border="1" cellpadding="8" cellspacing="0"
                     style="border-collapse: collapse; width: 100%; margin-bottom: 16px;">
                <thead>
                  <tr>
                    <th style="text-align:left;">Month</th>
                    <th style="text-align:right;">Total</th>
                    <th style="text-align:right;">Google</th>
                    <th style="text-align:right;">Email/Password</th>
                  </tr>
                </thead>
                <tbody>
            `;

                yearBuckets[year].forEach(function (m) {
                  var monthName = m.label.replace(year, "").trim();
                  html += `
                <tr>
                  <td>${monthName}</td>
                  <td style="text-align:right;">${m.total}</td>
                  <td style="text-align:right;">${m.google}</td>
                  <td style="text-align:right;">${m.email}</td>
                </tr>
              `;
                });

                html += `
                </tbody>
              </table>
            `;
              });

              providerCountDiv.innerHTML = html;
            } else if (data && data.message) {
              providerCountDiv.textContent = "Error: " + data.message;
            } else {
              providerCountDiv.textContent = "Unexpected response";
            }
          })
          .catch(function (err) {
            console.error("Fetch error (provider-counts)", err);
            providerCountDiv.textContent = "Request failed: " + err.message;
          });
      });
    }

    // ------------------
    // Active users count in one month
    // ------------------

    var activeButton = document.getElementById("active_ac_xport");
    var activeTarget = document.getElementById("active_ac_count");

    if (activeButton && activeTarget) {
      activeButton.addEventListener("click", function (e) {
        e.preventDefault();
        activeTarget.textContent = "Loading…";

        fetch("/myhoover/active-users-30-days", {
          method: "GET",
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
          },
        })
          .then(function (resp) {
            if (!resp.ok) {
              throw new Error("Network response was not OK: " + resp.status);
            }
            return resp.json();
          })
          .then(function (data) {
            if (data && data.success) {
              var count = data.active_users_last_30_days || 0;

              activeTarget.innerHTML = `
            <h3 style="margin-bottom: 10px;">
              Active Users (Last 30 Days)
            </h3>

            <div style="
              font-size: 32px;
              font-weight: bold;
              color: #98002e;
              margin: 8px 0;
            ">
              ${count}
            </div>

            <p style="color: #666; font-size: 13px;">
              Users who visited the site at least once in the last 30 days.
            </p>
          `;
            } else if (data && data.message) {
              activeTarget.textContent = "Error: " + data.message;
            } else {
              activeTarget.textContent = "Unexpected response";
            }
          })
          .catch(function (err) {
            console.error("Fetch error (inactive-accounts)", err);
            activeTarget.textContent = "Request failed: " + err.message;
          });
      });
    }

    (function () {
      function loadActiveUsers(days, target) {
        if (!target) {
          return;
        }

        target.textContent = "Loading…";

        fetch("/myhoover/active-users-" + days + "-days", {
          method: "GET",
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
          },
        })
          .then(function (resp) {
            if (!resp.ok) {
              throw new Error("Network response was not OK: " + resp.status);
            }
            return resp.json();
          })
          .then(function (data) {
            if (data && data.success) {
              var count = data.active_users || 0;

              target.innerHTML = `
            <h3 style="margin-bottom: 10px;">
              Active Users (Last ${days} Days)
            </h3>

            <div style="
              font-size: 32px;
              font-weight: bold;
              color: #98002e;
              margin: 8px 0;
            ">
              ${count}
            </div>

            <p style="color: #666; font-size: 13px;">
              Users who visited the site at least once in the last ${days} days.
            </p>
          `;
            } else if (data && data.message) {
              target.textContent = "Error: " + data.message;
            } else {
              target.textContent = "Unexpected response";
            }
          })
          .catch(function (err) {
            console.error("Fetch error (active-users)", err);
            target.textContent = "Request failed: " + err.message;
          });
      }

      // Button bindings
      var btn21 = document.getElementById("active_ac_xport_21Days");
      var target21Days = document.getElementById("active_ac_count_21");
      var target15Days = document.getElementById("active_ac_count_15");
      var target7Days = document.getElementById("active_ac_7_days");
      var btn15 = document.getElementById("active_ac_xport_15Days");
      var btn7 = document.getElementById("active_ac_xport_7Days");

      if (btn21) {
        btn21.addEventListener("click", function (e) {
          e.preventDefault();
          loadActiveUsers(21, target21Days);
        });
      }

      if (btn15) {
        btn15.addEventListener("click", function (e) {
          e.preventDefault();
          loadActiveUsers(15, target15Days);
        });
      }

      if (btn7) {
        btn7.addEventListener("click", function (e) {
          e.preventDefault();
          loadActiveUsers(7, target7Days);
        });
      }
    })();

    let monthlyActivityBtn = document.getElementById("monthly_active_usrs");
    let monthlyActiveTarget = document.getElementById("monthly_actv_usrs_wrap");

    if (monthlyActivityBtn && monthlyActiveTarget) {
      monthlyActivityBtn.addEventListener("click", function (e) {
        e.preventDefault();
        monthlyActiveTarget.textContent = "Loading…";

        fetch("/myhoover/active-users-monthwise", {
          method: "GET",
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
          },
        })
          .then(function (resp) {
            if (!resp.ok) {
              throw new Error("Network response was not OK: " + resp.status);
            }
            return resp.json();
          })
          .then(function (data) {
            if (!data || !data.success || !data.data) {
              monthlyActiveTarget.textContent = "No data available";
              return;
            }

            renderMonthwiseTable(data.data);
          })
          .catch(function (err) {
            console.error("Fetch error (monthly-counts)", err);
            monthlyActiveTarget.textContent = "Request failed: " + err.message;
          });
      });
    }

    function renderMonthwiseTable(data) {
      // Group by year
      const grouped = {};

      Object.keys(data).forEach(function (key) {
        const parts = key.split("-");
        const year = parts[0];
        const month = parts[1];

        if (!grouped[year]) {
          grouped[year] = [];
        }

        grouped[year].push({
          month: month,
          count: data[key],
        });
      });

      // Month labels
      const monthNames = [
        "",
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      let html = "";

      Object.keys(grouped)
        .sort((a, b) => b.localeCompare(a))
        .forEach(function (year) {
          html += `
      <div style="margin-bottom: 30px;">
        <h2 style="
          text-align: center;
          margin-bottom: 15px;
          color: #98002e;
        ">
          ${year}
        </h2>

        <table style="
          width: 100%;
          border-collapse: collapse;
          font-size: 14px;
        ">
          <thead>
            <tr style="background: #f5f5f5;">
              <th style="padding: 8px; border: 1px solid #ddd;">Month</th>
              <th style="padding: 8px; border: 1px solid #ddd; text-align: right;">Active Users</th>
            </tr>
          </thead>
          <tbody>
    `;

          grouped[year].forEach(function (row) {
            html += `
        <tr>
          <td style="padding: 8px; border: 1px solid #ddd;">
            ${monthNames[parseInt(row.month, 10)]}
          </td>
          <td style="padding: 8px; border: 1px solid #ddd; text-align: right;">
            ${row.count}
          </td>
        </tr>
      `;
          });

          html += `
          </tbody>
        </table>
      </div>
    `;
        });

      monthlyActiveTarget.innerHTML = html;
    }


   let monthlyInActivityBtn = document.getElementById("monthly_inactive_usrs");
    let monthlyInActiveTarget = document.getElementById("monthly_inactv_usrs_wrap");

    if (monthlyInActivityBtn && monthlyInActiveTarget) {
      monthlyInActivityBtn.addEventListener("click", function (e) {
        e.preventDefault();
        monthlyInActiveTarget.textContent = "Loading…";

        inactiveUsers()
      })
    }
    function inactiveUsers() {
      fetch("/myhoover/inactive-users", {
        method: "GET",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
        },
      })
        .then(function (resp) {
          if (!resp.ok) {
            throw new Error("Network response was not OK: " + resp.status);
          }
          return resp.json();
        })
        .then(function (data) {

          if (!data || !data.inactive) {
            monthlyActiveTarget.textContent = "No inactive data available";
            return;
          }

          renderInactiveMonthwiseTable(data.inactive, data.total_users);
        })
        .catch(function (err) {
          console.error("Fetch error (inactive-users)", err);
          monthlyActiveTarget.textContent = "Request failed: " + err.message;
        });
    }
    
    function renderInactiveMonthwiseTable(data, totalUsers) {

      const grouped = {};

      Object.keys(data).forEach(function (key) {
        const [year, month] = key.split("-");

        if (!grouped[year]) {
          grouped[year] = [];
        }

        grouped[year].push({
          month: month,
          count: data[key],
        });
      });

      const monthNames = [
        "",
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      let html = "";
      
      Object.keys(grouped)
        .sort((a, b) => b.localeCompare(a))
        .forEach(function (year) {

          html += `
            <div style="margin-bottom: 30px;">
              <h2 style="text-align:center;color:#98002e;">
                ${year}
              </h2>

              <table style="width:100%;border-collapse:collapse;font-size:14px;">
                <thead>
                  <tr style="background:#f5f5f5;">
                    <th style="padding:8px;border:1px solid #ddd;">Month</th>
                    <th style="padding:8px;border:1px solid #ddd;text-align:right;">
                      Inactive Users
                    </th>
                  </tr>
                </thead>
                <tbody>
          `;

          grouped[year].forEach(function (row) {
            html += `
              <tr>
                <td style="padding:8px;border:1px solid #ddd;">
                  ${monthNames[parseInt(row.month, 10)]}
                </td>
                <td style="padding:8px;border:1px solid #ddd;text-align:right;">
                  ${row.count}
                </td>
              </tr>
            `;
          });

          html += `
                </tbody>
              </table>
            </div>
          `;
        });

      monthlyInActiveTarget.innerHTML = html;
    }

    // ------------------
    // Weekly Plus Users
    // ------------------

    let weeklyPlusBtn = document.getElementById("weekly_plus_usrs");
    let weeklyPlusTarget = document.getElementById("weekly_plus_usrs_wrap");
    console.log(weeklyPlusBtn, weeklyPlusTarget)
    if (weeklyPlusBtn && weeklyPlusTarget) {
      weeklyPlusBtn.addEventListener("click", function (e) {
        e.preventDefault();
        weeklyPlusTarget.textContent = "Loading…";

        // Ensure this URL matches the path you set in myhoover.routing.yml
        fetch("/api/myhoover/reports/weekly-plus-users", {
          method: "GET",
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
          },
        })
          .then(function (resp) {
            if (!resp.ok) {
              throw new Error("Network response was not OK: " + resp.status);
            }
            return resp.json();
          })
          .then(function (data) {
            if (data && data.summary) {
              let breakdowns = data.breakdowns || {};
              let source = breakdowns.source || {};
              let landing = breakdowns.landing_page || {};
              let acctType = breakdowns.account_type || {};

              let html = `
                <h3 style="margin-bottom: 10px;">Weekly Plus Users</h3>
                <p style="font-size: 14px; color: #666;">
                  From <strong>${data.timeframe.start}</strong> to <strong>${data.timeframe.end}</strong>
                </p>
                <div style="font-size: 24px; font-weight: bold; color: #98002e; margin: 8px 0 20px;">
                  Total Accounts: ${data.summary.total_plus_accounts}
                </div>
              `;

              // Helper function to render tables for the breakdowns
              function renderTable(title, dataObj, keyLabel) {
                let tableHtml = `
                  <h4 style="margin: 15px 0 8px 0; color: #333;">${title}</h4>
                  <table border="1" cellpadding="8" cellspacing="0" style="border-collapse: collapse; width: 100%; margin-bottom: 24px; font-size: 14px;">
                    <thead>
                      <tr style="background: #f5f5f5;">
                        <th style="text-align:left;">${keyLabel}</th>
                        <th style="text-align:right;">Raw Count</th>
                        <th style="text-align:right;">Percentage</th>
                      </tr>
                    </thead>
                    <tbody>
                `;

                Object.keys(dataObj).forEach(function(key) {
                  let formattedKey = key;
                  // Capitalize the first letter for source and account type keys for better presentation
                  if (title !== "By Landing Page") {
                    formattedKey = key.charAt(0).toUpperCase() + key.slice(1);
                  }

                  tableHtml += `
                    <tr>
                      <td>${formattedKey}</td>
                      <td style="text-align:right;">${dataObj[key].raw_count}</td>
                      <td style="text-align:right;">${dataObj[key].percentage}</td>
                    </tr>
                  `;
                });

                tableHtml += `</tbody></table>`;
                return tableHtml;
              }

              if (data.summary.total_plus_accounts > 0) {
                html += renderTable("By Source", source, "Provider");
                html += renderTable("By Landing Page", landing, "URL");
                html += renderTable("By Account Type", acctType, "Type");
              } else {
                html += `<p style="color: #666; font-size: 14px;">No accounts were created in the last 7 days via URLs containing "plus".</p>`;
              }

              weeklyPlusTarget.innerHTML = html;
            } else if (data && data.message) {
              weeklyPlusTarget.textContent = "Error: " + data.message;
            } else {
              weeklyPlusTarget.textContent = "Unexpected response structure";
            }
          })
          .catch(function (err) {
            console.error("Fetch error (weekly-plus-users)", err);
            weeklyPlusTarget.textContent = "Request failed: " + err.message;
          });
      });
    }

  });
})();

